import React from "react";
import { useSelector } from "react-redux";

function DevOps() {
  const es_en = useSelector((state) => state.translation);
  return (
    <div className="skills__content">
      <h3 className="skills__title">
        {es_en ? "DevOps / Infraestructure" : "DevOps / Infraestructura"}
      </h3>
      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <box-icon name="docker" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Docker</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="github" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Github</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="github" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">GitHub Actions</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon type="logo" name="kubernetes" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Kubernetes</h3>
            </div>
          </div>
        </div>
        <div className="skills__group">
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Jenkins</h3>
              {/* <span className="skills__level">{ es_en ? "Medium" : "Medio"}</span> */}
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="aws" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">AWS</h3>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">CI/CD</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="git" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Git</h3>
              {/* <span className="skills__level">{ es_en ? "Medium" : "Medio"}</span> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DevOps;
